async function initFeishuServices(vueAppMode, subAppCode) {
  try {
    console.log("\u52A0\u8F7D\u98DE\u4E66 Services");
    const { initServices } = await import("@oppein-component-plus/services");
    console.log("\u98DE\u4E66 Services \u521D\u59CB\u5316\u4E2D...");
    initServices(vueAppMode, subAppCode);
    console.log("\u98DE\u4E66 Services \u521D\u59CB\u5316\u6210\u529F");
  } catch (error) {
    console.error("\u98DE\u4E66 Services \u521D\u59CB\u5316\u5931\u8D25:", error);
    throw error;
  }
}
let feishuInitPromise = null;
function initFeishuJSAPI(vueAppMode, subAppCode, appSource, apiList) {
  if (feishuInitPromise) {
    return feishuInitPromise;
  }
  feishuInitPromise = (async () => {
    try {
      await initFeishuServices(vueAppMode, subAppCode);
      const { configJSAPIAccess, sdkReady } = await import("@oppein-component-plus/feishu-sdk");
      console.log("\u7B49\u5F85\u98DE\u4E66 SDK \u51C6\u5907\u5C31\u7EEA...");
      const isReady = await sdkReady(1e4);
      if (!isReady) {
        throw new Error("\u98DE\u4E66 SDK \u521D\u59CB\u5316\u8D85\u65F6");
      }
      console.log("\u8FDB\u884C JSAPI \u9274\u6743\u914D\u7F6E... 9.36");
      const appIdMap = {
        group: "",
        agent: "cli_a885ab1724d0101c"
      };
      const success = await configJSAPIAccess(appIdMap[appSource], apiList, appSource);
      if (!success) {
        throw new Error("\u98DE\u4E66 JSAPI \u9274\u6743\u5931\u8D25");
      }
      console.log("\u98DE\u4E66 JSAPI \u9274\u6743\u6210\u529F");
    } catch (error) {
      console.error("\u98DE\u4E66 JSAPI \u521D\u59CB\u5316\u5931\u8D25:", error);
      feishuInitPromise = null;
      throw error;
    }
  })();
  return feishuInitPromise;
}
export { initFeishuJSAPI };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/feishu/initFeishuSdk.js